export default __webpack_public_path__ + "static/media/partner-wsg-swarovski.412d2a63.webp";